import React from 'react';
import classNames from 'classnames';
import { Carousel, SubTitle } from 'components';
import { FormattedMessage } from 'react-intl';
import ultilitiesService from 'shared/util/ultilitiesService';
import './KeyFacts.scss';

const KeyFacts = ({
  title, data, altStyle, dateUpdated,
}) => {
  const classes = classNames({
    'nw-fundfactsheet-keyfacts': true,
    'nw-fundfactsheet-keyfacts--alt': altStyle,
  });

  return (
    <div className={classes}>
      <SubTitle title={(
        <>
          <FormattedMessage id={title} />
          {dateUpdated && (
            <small className="date-updated">
              <FormattedMessage id="asOf" />
              <em>{ultilitiesService.formatDate(dateUpdated)}</em>
            </small>
          )}
        </>
      )}
      />
      {data && (
      <Carousel variableWidth>
        {data.map(item => (
          <div className="nw-fundfactsheet-keyfacts__fact" key={item.title}>
            <h4>{item.value}</h4>
            <p>
              <FormattedMessage id={item.title} />
              {' '}
              {` ${item.date ? `(${item.date})` : ''}`}
            </p>
            {item.subTitle && <p>{<FormattedMessage id={item.subTitle} />}</p>}
          </div>
        ))}
      </Carousel>
      )}
    </div>
  );
};

export default KeyFacts;
